import { confirmBase } from 'utils/ui'
import { redirectToMasterPwReenter } from 'pUtils'

// stale UMK(다른 기기에서 마스터 비밀번호 변경) 공통 안내 팝업 —
// [잠금화면으로 이동]=redirectToMasterPwReenter, [취소]=아무 동작 없이 닫기(현재 화면 유지).
// Settings/index.js 의 recovery_option 845 팝업과 동일 UX. 기본 문구는 패스키 등록 실패용
// (passkeyDeviceStaleSession) — 다른 플로우(새 복구 키 생성 등)는 title/content 로 자기 문구를 넘긴다.
export const showStaleSessionPopup = (t, { title, content } = {}) =>
  confirmBase({
    icon: 'red',
    width: 480,
    title: title || t('appConfig.settings.passkeyDeviceStaleSession.title'),
    content: content || t('appConfig.settings.passkeyDeviceStaleSession.description'),
    okText: t('common.button.goToLockScreen'),
    cancelText: t('common.button.cancel'),
    onOk: redirectToMasterPwReenter,
  })

export default showStaleSessionPopup
